export { renderTagPickerGroup_unstable as renderTagPickerGroup } from '@fluentui/react-tag-picker';
